export default __webpack_public_path__ + "static/media/designationLevelIcon.adf9948d.svg";